import Completion from '../../../../common/rooms/details/completion/Completion';
import { CmsContent, FlowData, Room, getConfigKey, EVENT_FLOW_CONFIGS } from '../../../../common/proctorStepsTypes';
import { useStateValue } from '../../../../../../context/AppContext';
import { useSkipLink } from '../../../../../../hooks/useSkipLink';

function TestCompletion({ flowData, room, cmsContent }: { flowData: FlowData; room: Room; cmsContent: CmsContent }) {
  const { orgEvent } = useStateValue();

  const configKey = getConfigKey(orgEvent);
  const {
    introStep,
    outerStep,
    progressStepperMax,
    steps: selectedStepDetails,
  } = EVENT_FLOW_CONFIGS[configKey].completion;

  useSkipLink(room.id);

  return (
    <Completion
      flowData={flowData}
      room={room}
      cmsContent={cmsContent}
      progressStepperMax={progressStepperMax}
      stepDetails={selectedStepDetails}
      introStep={introStep}
      outerStep={outerStep}
    />
  );
}

export default TestCompletion;
